import React from 'react';
import cn from 'classnames'

import './index.scss';

const Button = ({ isDisabled, onClick }) => {

  return <button className={cn('btn-calculate', isDisabled && 'btn-calculate__disabled')} disabled={isDisabled}
              onClick={onClick}>Calculate</button>;
};

export default Button;
